import { render } from "./TmfDocReviewList.vue?vue&type=template&id=698357f8&scoped=true"
import script from "./TmfDocReviewList.js?vue&type=script&lang=js"
export * from "./TmfDocReviewList.js?vue&type=script&lang=js"

import "./TmfDocReviewList.vue?vue&type=style&index=0&id=698357f8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698357f8"]])

export default __exports__